import React from 'react';

import WsIconProps from './IconProps';

const Visa: React.FC<WsIconProps> = ({ color = '#11151C', width = 16, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 3.01697L7.54974 3.83374L10 3.83374V3.01697ZM4.66671 13.8337L4.66671 5.16707H11.3334V13.8337H4.66671ZM3.33337 4.79475V5.16707V13.8337L3.3334 13.8424C3.33347 13.8537 3.33369 13.865 3.33404 13.8762C3.33645 13.9535 3.34544 14.0291 3.36046 14.1025C3.48479 14.71 4.02238 15.1671 4.66671 15.1671H11.3334C12.0698 15.1671 12.6667 14.5701 12.6667 13.8337V5.16707C12.6667 4.43069 12.0698 3.83374 11.3334 3.83374V3.01697C11.3334 2.1069 10.4418 1.46427 9.5784 1.75206L4.24507 3.52984C3.70061 3.71132 3.33337 4.22084 3.33337 4.79475ZM6.66671 9.16707C6.29852 9.16707 6.00004 9.46555 6.00004 9.83374C6.00004 10.2019 6.29852 10.5004 6.66671 10.5004H9.33337C9.70156 10.5004 10 10.2019 10 9.83374C10 9.46555 9.70156 9.16707 9.33337 9.16707H6.66671ZM6.00004 11.8337C6.00004 11.4656 6.29852 11.1671 6.66671 11.1671H8.00004C8.36823 11.1671 8.66671 11.4656 8.66671 11.8337C8.66671 12.2019 8.36823 12.5004 8.00004 12.5004H6.66671C6.29852 12.5004 6.00004 12.2019 6.00004 11.8337ZM8.00004 8.50041C8.73642 8.50041 9.33337 7.90345 9.33337 7.16707C9.33337 6.43069 8.73642 5.83374 8.00004 5.83374C7.26366 5.83374 6.66671 6.43069 6.66671 7.16707C6.66671 7.90345 7.26366 8.50041 8.00004 8.50041Z"
      fill={color}
      fillOpacity="0.5"
    />
  </svg>
);

export default Visa;
